var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBinDeleteRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,14V42a1,1,0,0,0,1,1H36a1,1,0,0,0,1-1l-.0006-28Zm7,24H16V19h2Zm7,0H23V19h2Zm7,0H30V19h2ZM39,8v4H9V8h8.9994l1-3h10l1,3Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinDeleteRgbRed);
export default __webpack_public_path__ + "static/media/trash_bin_delete_rgb_red.c660986d3ebd67d6da8884b93c794114.svg";
export { ForwardRef as ReactComponent };